import { SVGProps } from 'react';

export const IconCheckCircle = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 20 20' fill='none'>
      <path
        d='M10.0003 18.3334C14.6027 18.3334 18.3337 14.6024 18.3337 10.0001C18.3337 5.39771 14.6027 1.66675 10.0003 1.66675C5.39795 1.66675 1.66699 5.39771 1.66699 10.0001C1.66699 14.6024 5.39795 18.3334 10.0003 18.3334ZM14.5479 7.88101L9.16699 13.2619L5.66107 9.756L6.83958 8.5775L9.16699 10.9049L13.3694 6.70249L14.5479 7.88101Z'
        fill='currentColor'
      />
    </svg>
  );
};
